import React from 'react';
import {Modal, View, Text} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import Button from '../../elements/Button';
import RippleAnimation from '../../elements/RippleAnimation';
import makeStyles from './styles';

const BottomExpandableDrawer = ({
  testID = tID('BottomExpandableDrawer-Modal-Main'),
  visible,
  showRipple,
  rippleColor,
  title,
  subtitle,
  onClose,
  buttons = [],
  rippleIcon,
  iconSize,
  textAlign,
  modalStyle = {},
  containerStyle = {},
  modalViewStyle = {},
  titleStyle = {},
  subtitleStyle = {},
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Modal
      testID={testID}
      transparent
      visible={visible}
      onRequestClose={() => onClose?.()}
      animationType="slide"
      style={modalStyle}
    >
      <View
        testID={tID('BottomExpandableDrawer-View-Container')}
        style={[styles.container, containerStyle]}
      >
        <SafeAreaView style={[styles.safeareaContainer, modalViewStyle]}>
          <View style={styles.bottomContainer}>
            <Text
              testID={tID('BottomExpandableDrawer-Text-Title')}
              style={[styles.title, titleStyle, {textAlign}]}
            >
              {title}
            </Text>
            <Text
              testID={tID('BottomExpandableDrawer-Text-SubTitle')}
              style={[styles.subtitle, subtitleStyle, {textAlign}]}
            >
              {subtitle}
            </Text>

            {showRipple && (
              <View style={styles.rippleContainer}>
                <RippleAnimation
                  color={rippleColor}
                  icon={rippleIcon}
                  iconSize={iconSize}
                />
              </View>
            )}

            {buttons.length > 0 && (
              <View style={styles.buttonsContainer}>
                {buttons.map((button, index) => (
                  <Button
                    testID={tID(`BottomExpandableDrawer-Button-${index + 1}`)}
                    key={index}
                    style={[
                      styles.button,
                      {marginLeft: index == 0 ? 0 : 16},
                      button.style,
                    ]}
                    buttonType={button.buttonType}
                    titleColor={
                      button.buttonType == BUTTON_TYPES.Filled
                        ? colors.textOnAccent
                        : undefined
                    }
                    title={button.title}
                    onPress={button.onPress}
                  />
                ))}
              </View>
            )}
          </View>
        </SafeAreaView>
      </View>
    </Modal>
  );
};

export default BottomExpandableDrawer;
